import { CART_REVAMP_TRACKER_TYPE } from '../../../../shop/constants/tracker';
import { getInjector } from '../../utils/getInjector';

export const onTrackPaymentPromoOptionClick = async () => {
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');

  trackerService.track({
    type: CART_REVAMP_TRACKER_TYPE.PaymentPromoOptionClick,
    data: {
      scope: 'shop',
      event_category: 'Cart',
    },
  });
};
